import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";
import { format, addDays, subDays, isToday } from "date-fns";
import { ArrowLeft, ArrowRight } from 'lucide-react';

import ServiceBooking from 'services/serviceBooking';
import moment from 'moment';

const bookingStatuses = {
    canceled: "bg-red-500",
    ongoing: "bg-orange-500",
    booked: "bg-blue-500",
    complete: "bg-green-700",
}

const statusLabels = {
    overdue: "Overdue Checkout",
    ongoing: "Ongoing Booking",
    upcoming: "Upcoming Booking (No Payment)",
    advanceUpcoming: "Upcoming Booking (Advance Paid)",
    completed: "Completed (Advance)",
}

const ComponentBookingGrid = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({
        refresh() {
            loadData();
        }
    }));

    const [bookings, setBookings] = useState([]);

    const bookingService = new ServiceBooking();

    const [startDate, setStartDate] = useState(subDays(new Date(), 5));

    const visibleDates = Array.from({ length: 10 }, (_, i) =>
        addDays(startDate, i)
    )

    const handlePrev = () => {
        setStartDate(prev => subDays(prev, 1));
        loadData();
    }
    const handleNext = () => {
        setStartDate(prev => addDays(prev, 1));
        loadData();
    }

    const onBarClick = (bookingId) => {
        console.log("Clicked booking ID:", bookingId)
        // You can trigger modal or route here
    }

    const getBookingForRoomAndDate = (book, date) => {
        return bookings.filter((b) => b.bookID === book.bookID && moment(date).isSameOrAfter(moment(b.checkIn), 'day') &&
            moment(date).isSameOrBefore(moment(b.checkOut), 'day'))[0];
    }

    const loadData = () => {
        (async function () {
            const start = startDate;
            const end = addDays(startDate, 10);
            var res = await bookingService.getBookingsByFilter({
                checkIn: {
                    $gte: new Date(start),
                    $lte: new Date(end)
                }
            }, '');
            setBookings(res.data);
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className="h-full w-full px-2 py-2">
            <div className="flex items-center justify-between mb-2">
                <div className='w-10 h-10 bg-prime rounded flex items-center justify-center text-white' onClick={() => { handlePrev() }}><ArrowLeft size={18} /></div>
                <div className="grid grid-cols-10 gap-1 w-full mx-2">
                    {
                        visibleDates.map((date, idx) => (
                            <div key={idx} className={`bg-white text-center p-1 rounded hover:bg-red-100 cursor-pointer border border-dashed ${isToday(date) ? "font-bold text-prime border-prime" : "text-black border-gray-200"}`}>
                                {format(date, "dd MMM")}
                            </div>
                        ))
                    }
                </div>
                <div className='w-10 h-10 bg-prime rounded flex items-center justify-center text-white' onClick={() => { handleNext() }}><ArrowRight size={18} /></div>
            </div>
            <ScrollArea className="w-full h-[80vh] rounded border bg-white p-2">
                <div className="flex flex-col space-y-2">
                    {bookings.map((book, idx) => (
                        <div key={idx}>
                            <div className="text-sm font-medium mb-1">{book.bookID}</div>
                            <div className="grid grid-cols-10 gap-[2px]">
                                {
                                    visibleDates.map((date, i) => {
                                        const booking = getBookingForRoomAndDate(book, date);
                                        return (
                                            <div key={i} className="h-10">
                                                {
                                                    booking !== undefined ? (
                                                        <div className={`h-full w-full cursor-pointer rounded-sm ${bookingStatuses[booking.status]}`} title={`Booking ID: ${booking.id}`} onClick={() => onBarClick(booking._id)} />
                                                    ) : (
                                                        <div className="h-full w-full bg-gray-100 rounded-sm" />
                                                    )
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    ))}
                </div>
            </ScrollArea>
            <div className="mt-4 border-t pt-2">
                <div className="flex items-center gap-2">
                    {Object.entries(statusLabels).map(([key, label]) => (
                        <div key={key} className="flex items-center gap-2">
                            <div className={`w-4 h-4 rounded-sm ${bookingStatuses[key]}`} />
                            <span className="text-sm">{label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
});

export default ComponentBookingGrid;